import React, { useEffect, useState, memo, useRef, use, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_STATE } from '../../../actions/types';
import {
    Box, Tooltip,
    Typography,
    Tabs, Tab,
    Grid,
    IconButton,
    Button, Paper, Collapse, TextField
} from "@mui/material";

import { useFetchApi } from '../../../hooks/useFetchApi';
import EmptyScreen from "./EmptyScreen";
import { DateRangePicker } from "react-date-range";
import { dateFormat, deepCopy, userReadyOnlyStatus, } from "../../../app/util";
import { tagIcon, calendarIcon, copyIcon, arrowDownIcon, infoIconGrey, crossIcon, warningIcon } from "./icons";
// import originalData from './pricing-modal3.json';
import SkeletonLoader from './SkeletonLoader';
import SeasonAccordion from './SeasonAccordion';
import CustomTabPanel from './CustomTabPanel';
import { filterSeasons, checkHasError, checkDateOverlapError, getUsedDateFromSeasons, generateDefaultPricingSeason, generateUniqueSeasonName, itIsPricingModel3Data } from './function';

import ReCalibratePopup from './Popups/ReCalibratePopup'
import ReCalibratingPopup from './Popups/ReCalibratingPopup'
import UpdateRequiredPopup from './Popups/UpdateRequiredPopup'

import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbarsComponent, useOverlayScrollbars } from "overlayscrollbars-react";
import moment from 'moment';
import { toast } from 'react-toastify';

import dataService from "../../../services/data.service";
import { APP_CACHE } from '../../../app/config-v4-api';
import useUserLoginType from '../../../hooks/useUserLoginType';



function PricingSeasons(props) {
    const { isConfigured, setIsConfigured, inventoryRoomSettings } = props;

    const dispatch = useDispatch();
    const { profile } = useSelector(state => state.auth);
    const { property_details, display_name } = profile;
    const { app_state, ui_state } = useSelector(state => state.app.current_state);
    const { as_of_date } = app_state.primary_stay_range;

    const userLoginType = useUserLoginType();
    const usrReadyOnlyStatus = userReadyOnlyStatus(userLoginType);
    const compRef = useRef({ calibrateStatus: null });

    let prop_details_index = 0;
    const prop_details = property_details.find((item, index) => {
        if (item.id === app_state.property_id) {
            prop_details_index = index;
            return item.id === app_state.property_id;
        }
    });
    const { inventory_settings, pricing_settings, rate_source } = prop_details?.system_settings && prop_details?.system_settings[0] ? prop_details?.system_settings[0] : null;
    let { room_dow_plans } = pricing_settings || [];
    room_dow_plans = room_dow_plans.length && room_dow_plans[0]?.pricingModel === 3 ? room_dow_plans : [];
    const inventoryRoomCodes = [];
    inventory_settings.current.room_settings.forEach((item) => {
        if (item.room_lodgiq_code) inventoryRoomCodes.push(item.room_lodgiq_code);
    });
    // const inventoryRoomSettings = inventory_settings.current.room_settings;

    //Mark expired seasons if until date passed
    if (room_dow_plans && room_dow_plans.length > 0) {
        room_dow_plans.forEach((plan, i) => {
            // check plan.plan_period.effective_date_range.until is before today use moment then mark plan.status to  expired
            if (plan.isDefault === false && moment(plan.plan_period.effective_date_range.until).isBefore(moment(as_of_date).format('YYYY-MM-DD'))) {
                plan.status = 'expired';
            }
        })
    }
    let originalData = deepCopy(room_dow_plans);
    if (originalData.length && originalData[0].pricingModel !== 3) {
        originalData = [];
    }
    const pricingSeasons = itIsPricingModel3Data(app_state.pricingSeasons);
    // const pricingSeasons = { initial: [], updated: [] };

    const pricingSeasonsUI = deepCopy(ui_state.pricingSeasonsUI);
    const { openItemId, changeItemId, discardCount, globalErrorMsg, copyInputCount, tabPanelIndex, showRecalibratePopup, showRecalibratingPopup, isRecalibrating } = pricingSeasonsUI;

    const [newSeasonState, setNewSeasonState] = useState(null);
    const { activeSeasons, inactiveSeasons, expiredSeasons } = filterSeasons(pricingSeasons);

    const checkRecalibrationStatus = useCallback((interval = 10, avoidToast = false) => {
        if (interval > 0) {
            compRef.current.calibrateStatus = setInterval(() => {
                if (pricingSeasonsUI.isRecalibrating) {
                    try {
                        let requestAPI = "rms/properties/recalibrate/pricing-seasons/" + app_state.property_id + "/";
                        dataService.fetchDataSimple({ api: requestAPI, request: { method: 'GET' } })
                            .then((rs) => {
                                if (rs && rs.status === 'error') {
                                    pricingSeasonsUI.isRecalibrating = false;
                                    updatePricingSeasonsUI(pricingSeasonsUI);
                                    toast.error(<span><strong>{rs.message}</strong></span>, {
                                        position: "bottom-right",
                                        autoClose: 3000,
                                    });
                                }
                                if (rs && rs.status === 'completed') {
                                    pricingSeasonsUI.isRecalibrating = false;
                                    updatePricingSeasonsUI(pricingSeasonsUI);
                                    if (!avoidToast) {
                                        toast.success(<span><strong>{rs.message}</strong> Sell Rate Recalibration Completed. Recommendations Are Now up to Date</span>, {
                                            position: "bottom-right",
                                            autoClose: 5000,
                                        });
                                    }

                                }
                                if (rs && rs.status === 'in-progress') {
                                    pricingSeasonsUI.isRecalibrating = true;
                                    updatePricingSeasonsUI(pricingSeasonsUI);
                                }
                            },
                                (err) => {
                                    pricingSeasonsUI.isRecalibrating = false;
                                    updatePricingSeasonsUI(pricingSeasonsUI);
                                    toast.error(<span><strong>{err.toString()}</strong></span>, {
                                        position: "bottom-right",
                                        autoClose: 3000,
                                    });
                                });
                    } catch (err) {
                        pricingSeasonsUI.isRecalibrating = false;
                        updatePricingSeasonsUI(pricingSeasonsUI);
                        toast.error(<span><strong>{err.toString()}</strong></span>, {
                            position: "bottom-right",
                            autoClose: 3000,
                        });
                    }
                } else {
                    clearInterval(compRef.current.calibrateStatus);
                }
            }, interval * 1000);
        }
        if (interval == 0) {
            try {
                let requestAPI = "rms/properties/recalibrate/pricing-seasons/" + app_state.property_id + "/";
                dataService.fetchDataSimple({ api: requestAPI, request: { method: 'GET' } })
                    .then((rs) => {
                        if (rs && rs.status === 'in-progress') {
                            pricingSeasonsUI.isRecalibrating = true;
                            checkRecalibrationStatus();
                        } else {
                            pricingSeasonsUI.isRecalibrating = false;
                        }
                        updatePricingSeasonsUI(pricingSeasonsUI);
                    });
            } catch (err) {
                pricingSeasonsUI.isRecalibrating = false;
                updatePricingSeasonsUI(pricingSeasonsUI);
                toast.error(<span><strong>{err.toString()}</strong></span>, {
                    position: "bottom-right",
                    autoClose: 3000,
                });
            }
        }
    })
    const handleRecalibrate = () => {
        pricingSeasonsUI.isRecalibrating = true;
        pricingSeasonsUI.recalibrationStatus = 'in-progress'; //'started';
        updatePricingSeasonsUI(pricingSeasonsUI);

        try {
            let requestAPI = "rms/properties/recalibrate/pricing-seasons/" + app_state.property_id + "/";
            let IDs = pricingSeasons.sendForRecalibration.map((season) => season.id);
            dataService.fetchDataSimple({ api: requestAPI, request: { ids: IDs } })
                .then((rs) => {
                    if (rs && rs.status === 'error') {
                        pricingSeasonsUI.isRecalibrating = false;
                        updatePricingSeasonsUI(pricingSeasonsUI);
                        toast.error(<span><strong>{rs.message}</strong></span>, {
                            position: "bottom-right",
                            autoClose: 3000,
                        });
                    }
                    if (rs && rs.status === 'completed') {
                        toast.success(<span><strong>
                            Sell Rate Recalibration Completed for {app_state.property_name}.</strong> <br />
                            Recommendations Are Now up to Date</span>, {
                            position: "bottom-right",
                            autoClose: 5000,
                        });
                        updatePricingSeasons({ sendForRecalibration: [] });
                        updatePricingSeasonsUI({ isRecalibrating: false, recalibrationStatus: 'completed', showRecalibratePopup: false });
                    }
                    if (rs && rs.status === 'in-progress') {
                        toast.success(<span><strong>{rs.message}</strong> You Can Continue Using the App — We’ll Alert You Once Updates Are Complete.</span>, {
                            position: "bottom-right",
                            autoClose: 5000,
                        });

                        //Call check recalibration status
                        // checkRecalibrationStatus();
                        pricingSeasons.sendForRecalibration = [];
                        updatePricingSeasons(pricingSeasons);
                    }
                },
                    (err) => {
                        pricingSeasonsUI.isRecalibrating = false;
                        updatePricingSeasonsUI(pricingSeasonsUI);
                        toast.error(<span><strong>{err.toString()}</strong></span>, {
                            position: "bottom-right",
                            autoClose: 3000,
                        });
                    });
        } catch (err) {
            pricingSeasonsUI.isRecalibrating = false;
            updatePricingSeasonsUI(pricingSeasonsUI);
            toast.error(<span><strong>{err.toString()}</strong></span>, {
                position: "bottom-right",
                autoClose: 3000,
            });
        }
    }

    const closeRecalibratePopup = () => {
        pricingSeasonsUI.showRecalibratePopup = false; // close recalibrate popup
        updatePricingSeasonsUI(pricingSeasonsUI);
    }

    const closeRecalibratingPopup = () => {
        pricingSeasonsUI.showRecalibratingPopup = false; // close recalibrating popup
        updatePricingSeasonsUI(pricingSeasonsUI);
    }

    const isReadOnlyMode = tabPanelIndex === 2 || pricingSeasonsUI.isRecalibrating;
    const accordionRefs = useRef({});

    const scrollTopSeason = () => {
        const ref = accordionRefs.current[changeItemId];
        let shakeBtnDiv = ref?.getElementsByClassName("save-cancel-buttons");

        // Scroll top
        if (ref?.scrollIntoView) {
            setTimeout(() => {
                ref.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                });
            }, 50);
        }

        // Button shake animation
        if (shakeBtnDiv.length > 0) {
            Array.from(shakeBtnDiv).forEach((btnDiv) => {
                btnDiv.classList.add("bt-shake");
            });

            setTimeout(() => {
                Array.from(shakeBtnDiv).forEach((btnDiv) => {
                    btnDiv.classList.remove("bt-shake");
                });
            }, 2000);
        }
    };

    const handleTabChange = (event, newValue) => {
        if (changeItemId === null) {
            pricingSeasonsUI.openItemId = null;
            pricingSeasonsUI.tabPanelIndex = newValue;
            //pricingSeasonsUI.isRecalibrating = false;
            updatePricingSeasonsUI(pricingSeasonsUI);
        }
        else {
            scrollTopSeason(); // Scroll top the current editing season
        }
    };


    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function manageSeasonChangeFunc({ action, season }) {
        const editedSeason = deepCopy(season);
        // action updateBtn, discardBtn, inputChange
        const editedSeasonId = editedSeason.id;
        let initialSeason = {};
        if (editedSeasonId.toString().includes('new_')) {
            initialSeason = deepCopy(pricingSeasons.initial.find((s) => s.isDefault === true));
        } else {
            initialSeason = deepCopy([...pricingSeasons.updated, ...pricingSeasons.initial].find((s) => s.id === editedSeasonId));
        }

        // find editedSeason in pricingSeasons.updated
        const editedSeasonIndex = pricingSeasons.updated.findIndex((s) => s.id === editedSeasonId);
        //stringify initialSeason and season to find chenges
        const initialSeasonStr = JSON.stringify(initialSeason);
        const editedSeasonStr = JSON.stringify(editedSeason);

        const foundInitialSeason = deepCopy(pricingSeasons.initial.find((s) => s.id === editedSeasonId));
        const foundInitialSeasonStr = JSON.stringify(foundInitialSeason);

        // Check error 
        let hasError = checkHasError(initialSeason, editedSeason, pricingSeasons, inventoryRoomSettings);
        if (hasError === false) {
            if (tabPanelIndex !== 0) {
                if (season.status === 'active') {
                    // create dummy season to keep edited season Date to check in active seasons
                    const dummySeason = deepCopy(editedSeason);
                    dummySeason.plan_period.effective_date_range.from = '2025-01-01';
                    dummySeason.plan_period.effective_date_range.until = '2025-01-01';
                    hasError = checkDateOverlapError(editedSeason, pricingSeasons, dummySeason);
                }
            }
        }
        if (hasError) {
            pricingSeasonsUI.globalErrorMsg = [...globalErrorMsg, hasError];
            updatePricingSeasonsUI(pricingSeasonsUI);
        } else {
            pricingSeasonsUI.globalErrorMsg = [];
            updatePricingSeasonsUI(pricingSeasonsUI);;
        }

        if (initialSeasonStr === editedSeasonStr && !['discardBtn', 'cancelBtn', 'copyInput'].includes(action)) {
            pricingSeasonsUI.changeItemId = null;
            updatePricingSeasonsUI(pricingSeasonsUI);
            return;
        }

        switch (action) {
            case 'saveBtn':
                pricingSeasonsUI.changeItemId = null // unlock season from edit mode
                pricingSeasonsUI.openItemId = null // close accordion
                pricingSeasonsUI.globalErrorMsg = [];
                //pricingSeasonsUI.showRecalibratePopup = true; // show recalibrate popup
                updatePricingSeasonsUI(pricingSeasonsUI);
                setTimeout(() => {
                    const SaveSeasonIndex = pricingSeasons.updated.findIndex((s) => s.id.toString() === editedSeasonId.toString());
                    if (SaveSeasonIndex !== -1) {
                        pricingSeasons.updated[SaveSeasonIndex] = editedSeason;
                    }
                    else {
                        pricingSeasons.updated.push(editedSeason);
                    }
                    setNewSeasonState(null);
                    updatePricingSeasons(pricingSeasons);
                }, 500);
                break;
            case 'updateBtn':
                // Update Edited by and edited on 
                if (editedSeasonIndex === -1) {
                    // add editedSeason to pricingSeasons.updated
                    pricingSeasons.updated.push(editedSeason);
                } else {
                    // update editedSeason in pricingSeasons.updated
                    if (foundInitialSeason && foundInitialSeasonStr === editedSeasonStr) {
                        // remove editedSeason from pricingSeasons.updated
                        pricingSeasons.updated.splice(editedSeasonIndex, 1);

                    } else {
                        // update editedSeason in pricingSeasons.updated
                        pricingSeasons.updated[editedSeasonIndex] = editedSeason;
                    }

                }
                pricingSeasonsUI.changeItemId = null;
                pricingSeasonsUI.globalErrorMsg = [];
                updatePricingSeasonsAndUI(pricingSeasons, pricingSeasonsUI);
                break;
            case 'updateStatus':
                pricingSeasonsUI.openItemId = null;
                updatePricingSeasonsUI(pricingSeasonsUI);
                setTimeout(() => {
                    // find editedSeason id in pricingSeasons.updated and remove it
                    if (editedSeasonIndex === -1) {
                        pricingSeasons.updated.push(editedSeason);
                    }
                    else {
                        if (foundInitialSeason && foundInitialSeasonStr === editedSeasonStr) {
                            // remove editedSeason from pricingSeasons.updated
                            pricingSeasons.updated.splice(editedSeasonIndex, 1);

                        } else {
                            // update editedSeason in pricingSeasons.updated
                            pricingSeasons.updated[editedSeasonIndex] = editedSeason;
                        }
                    }
                    pricingSeasonsUI.changeItemId = null;
                    pricingSeasonsUI.globalErrorMsg = [];
                    updatePricingSeasonsAndUI(pricingSeasons, pricingSeasonsUI);
                }, 500);
                break;
            case 'cancelBtn':
                pricingSeasonsUI.openItemId = null;
                updatePricingSeasonsUI(pricingSeasonsUI);
                setTimeout(() => {
                    // if cancel new season then back to empty screen
                    if (newSeasonState.isDefault) {
                        setIsConfigured(0);
                    }
                    // remove editedSeason from pricingSeasons.initial
                    setNewSeasonState(null);
                    pricingSeasonsUI.changeItemId = null;
                    pricingSeasonsUI.globalErrorMsg = [];
                    updatePricingSeasonsUI(pricingSeasonsUI);
                }, 500);
                break;
            case 'discardBtn':

                pricingSeasonsUI.changeItemId = null;
                pricingSeasonsUI.discardCount = discardCount + 1;
                updatePricingSeasonsAndUI(pricingSeasons, pricingSeasonsUI);
                break;
            case 'inputChange':
                pricingSeasonsUI.changeItemId = editedSeasonId;
                updatePricingSeasonsUI(pricingSeasonsUI);
                break;
            case 'copyInput':
                pricingSeasonsUI.changeItemId = editedSeasonId;
                pricingSeasonsUI.copyInputCount = copyInputCount + 1;
                updatePricingSeasonsUI(pricingSeasonsUI);
                break;
            case 'offsetTypeChange':
                pricingSeasonsUI.changeItemId = editedSeasonId;
                pricingSeasonsUI.copyInputCount = copyInputCount + 1;
                updatePricingSeasonsUI(pricingSeasonsUI);
                break;
            case 'deactivateCheckbox':
                pricingSeasonsUI.changeItemId = editedSeasonId;
                updatePricingSeasonsUI(pricingSeasonsUI);
                break;
            default:
                break;
        }
    }

    const addNewPricingRule = (action, id = null) => {
        let newSeason = {};
        let numberOfDays = 0;
        const weekDaysValue = {
            "Sun": { min: null, max: null },
            "Mon": { min: null, max: null },
            "Tue": { min: null, max: null },
            "Wed": { min: null, max: null },
            "Thu": { min: null, max: null },
            "Fri": { min: null, max: null },
            "Sat": { min: null, max: null }
        }

        // Find season
        if (action === 'addNewSeason') {
            newSeason = deepCopy([...pricingSeasons.updated, ...pricingSeasons.initial].find((s) => s.isDefault === true));
            newSeason.plan_name = "New Season " + activeSeasons.length;
            newSeason.isRoomTypeDifference = false;
            Object.keys(newSeason.dependent_room_type.room_type).forEach((key) => {
                newSeason.dependent_room_type.room_type[key] = deepCopy(weekDaysValue);
            })
            pricingSeasonsUI.globalErrorMsg = [...globalErrorMsg, 'Please fill in all fields.'];
            newSeason.isDefault = false;
        }
        else if (action === 'addDefault') {
            const defaultRatePlanCode = rate_source?.resource_lookup?.rate_code || '';
            if (!defaultRatePlanCode) {
                console.error('rate_source.resource_lookup.rate_code is not configured');
            }
            //requestData.rate_source.resource_lookup.rate_code
            newSeason = generateDefaultPricingSeason(inventoryRoomSettings, defaultRatePlanCode || 'None');
            pricingSeasonsUI.globalErrorMsg = [...globalErrorMsg, 'Please fill in all fields.'];
        }
        else {
            newSeason = deepCopy([...pricingSeasons.updated, ...pricingSeasons.initial].find((s) => s.id === id));
            const searchableSeasons = [...activeSeasons, ...inactiveSeasons];
            newSeason.plan_name = generateUniqueSeasonName(newSeason.plan_name, searchableSeasons);
            // Find number of days in newSeason
            numberOfDays = moment(newSeason.plan_period.effective_date_range.until).diff(moment(newSeason.plan_period.effective_date_range.from), 'days');
            newSeason.isDefault = false;
            if (newSeason.isRoomTypeDifference || newSeason.isBaseRoomTypeChanged) {
                pricingSeasonsUI.globalErrorMsg = [...globalErrorMsg, 'Please fill in all fields.'];
            }

        }

        newSeason.id = "new_" + crypto.randomUUID(); //new Date().getTime();
        newSeason.status = "active";

        //find highest date in pricingSeasons.initial
        newSeason.plan_period.effective_date_range.from = '2025-01-01';
        newSeason.plan_period.effective_date_range.until = '2025-01-01';

        const { useDateYYYYMMDD } = getUsedDateFromSeasons(activeSeasons, newSeason);

        let highestDateFrom = moment().format('YYYY-MM-DD');
        let highestDateUntil = moment().format('YYYY-MM-DD');

        while (useDateYYYYMMDD.includes(highestDateFrom)) {
            highestDateFrom = moment(highestDateFrom).add(1, 'day').format('YYYY-MM-DD');
            highestDateUntil = highestDateFrom;
        }

        if (action === 'copyNewSeason' && numberOfDays > 0) {
            while (!useDateYYYYMMDD.includes(highestDateUntil)) {
                highestDateUntil = moment(highestDateUntil).add(1, 'day').format('YYYY-MM-DD');
                if (useDateYYYYMMDD.includes(highestDateUntil)) {
                    highestDateUntil = moment(highestDateUntil).subtract(1, 'day').format('YYYY-MM-DD');
                    break;
                }
                numberOfDays--;
                if (numberOfDays === 0) {
                    break;
                }
            }
        }

        newSeason.plan_period.effective_date_range.from = highestDateFrom;
        newSeason.plan_period.effective_date_range.until = highestDateUntil;
        newSeason.pricingModel = 3;

        pricingSeasonsUI.tabPanelIndex = 0;
        pricingSeasonsUI.changeItemId = newSeason.id;

        updatePricingSeasonsUI(pricingSeasonsUI);
        setNewSeasonState(newSeason);
        setTimeout(() => {
            pricingSeasonsUI.openItemId = newSeason.id;
            updatePricingSeasonsUI(pricingSeasonsUI);
        }, 500);
    }


    const updatePricingSeasons = (pricingSeasons) => {
        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    pricingSeasons: {
                        ...app_state.pricingSeasons,
                        ...pricingSeasons,
                    },
                }
            }
        });
    }

    const updatePricingSeasonsUI = (pricingSeasonsUI) => {
        APP_CACHE.pricingSeasonsUI = deepCopy(pricingSeasonsUI);
        dispatch({
            type: UPDATE_STATE,
            payload: {
                ui_state: {
                    pricingSeasonsUI: {
                        ...ui_state.pricingSeasonsUI,
                        ...pricingSeasonsUI,
                    },
                }
            }
        });
    }

    const updatePricingSeasonsAndUI = (pricingSeasons, pricingSeasonsUI) => {
        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    pricingSeasons: {
                        ...app_state.pricingSeasons,
                        ...pricingSeasons,
                    },
                },
                ui_state: {
                    pricingSeasonsUI: {
                        ...ui_state.pricingSeasonsUI,
                        ...pricingSeasonsUI,
                    },
                }
            }
        });
    }

    useEffect(() => {
        //Reset when reload browser after refresh or mounting
        setNewSeasonState(null);
        if (pricingSeasonsUI.openItemId) {
            pricingSeasonsUI.changeItemId = null;
            pricingSeasonsUI.openItemId = null;
            pricingSeasonsUI.globalErrorMsg = [];
            updatePricingSeasonsUI(pricingSeasonsUI);
        }
        //Fist time store api original data to redux
        if (originalData.length && originalData[0].room_plans) {
            originalData = [];
        }
        pricingSeasons.initial = originalData;
        pricingSeasons.updated = [];
        updatePricingSeasons(pricingSeasons);

        if (isConfigured) {
            pricingSeasonsUI.isRecalibrating = false;
            updatePricingSeasonsUI(pricingSeasonsUI);
            // checkRecalibrationStatus(0, true);
        }

    }, [app_state.property_id]);


    useEffect(() => {
        if (isConfigured === 1 && pricingSeasons.initial.length === 0 && pricingSeasons.updated.length === 0) {
            addNewPricingRule('addDefault');
        }
        return () => {
            pricingSeasonsUI.openItemId = null;
            updatePricingSeasonsUI(pricingSeasonsUI);
        }
    }, [isConfigured]);

    return (
        <Box sx={{ width: '100%' }} className='pricing-seasons-main-container'>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    className="mapping-tabs pricing-seasons"
                    value={tabPanelIndex}
                    onChange={handleTabChange}
                    aria-label="pricing seasons tabs"
                >
                    <Tab label={`Active ${activeSeasons?.length > 0 ? `(${activeSeasons.length})` : ''}`} {...a11yProps(0)} />
                    <Tab label={`Inactive ${inactiveSeasons?.length > 0 ? `(${inactiveSeasons.length})` : ''}`} {...a11yProps(1)} />
                    <Tab label={`Expired ${expiredSeasons?.length > 0 ? `(${expiredSeasons.length})` : ''}`} {...a11yProps(2)} />
                </Tabs>
            </Box>

            <CustomTabPanel className="custom-tab-panel active" value={tabPanelIndex} index={0}>
                {/* {isDataLoading && <SkeletonLoader />} */}

                {isConfigured ? (
                    <>
                        <OverlayScrollbarsComponent
                            className="custom-overlay-scrollbar scrollable-tab-container"
                            element="div"
                            options={{
                                scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                                overflow: { x: 'hidden', y: 'scroll', }
                            }}
                            defer
                        >
                            <Box className="tab-container active">
                                {activeSeasons.find((season) => season.isRoomTypeDifference === true || season.isBaseRoomTypeChanged === true) &&
                                    <Box className="warning-container">
                                        {warningIcon}
                                        <Box className="warning-msg">Inventory changes have cleared some pricing rules. Please review and update to continue.</Box>
                                    </Box>
                                }
                                {activeSeasons.map((season, i) => {
                                    //Filter tabs
                                    return (
                                        <SeasonAccordion
                                            key={season.id}
                                            ref={(el) => (accordionRefs.current[season.id] = el)}
                                            season={season}
                                            updatePricingSeasonsUI={updatePricingSeasonsUI}
                                            manageSeasonChangeFunc={manageSeasonChangeFunc}
                                            isReadOnlyMode={isReadOnlyMode}
                                            discardCount={discardCount}
                                            globalErrorMsg={globalErrorMsg}
                                            copyInputCount={copyInputCount}
                                            addNewPricingRule={addNewPricingRule}
                                            scrollTopSeason={scrollTopSeason}
                                            tab="active"
                                            inventoryRoomCodes={inventoryRoomCodes}
                                            inventoryRoomSettings={inventoryRoomSettings}
                                        />
                                    )
                                })}
                                {newSeasonState && (
                                    <SeasonAccordion
                                        key={newSeasonState.id}
                                        ref={(el) => (accordionRefs.current[newSeasonState.id] = el)}
                                        season={newSeasonState}
                                        updatePricingSeasonsUI={updatePricingSeasonsUI}
                                        manageSeasonChangeFunc={manageSeasonChangeFunc}
                                        isReadOnlyMode={isReadOnlyMode}
                                        discardCount={discardCount}
                                        globalErrorMsg={globalErrorMsg}
                                        copyInputCount={copyInputCount}
                                        addNewPricingRule={addNewPricingRule}
                                        scrollTopSeason={scrollTopSeason}
                                        tab="active"
                                        inventoryRoomCodes={inventoryRoomCodes}
                                        inventoryRoomSettings={inventoryRoomSettings}
                                    />
                                )
                                }
                            </Box>
                        </OverlayScrollbarsComponent>

                        {!usrReadyOnlyStatus && (openItemId === null && !isRecalibrating) ?
                            <Button
                                disabled={openItemId !== null}
                                variant="outlined"
                                className="add-button"
                                size="small"
                                sx={{ lineHeight: "auto" }}
                                onClick={() => {
                                    addNewPricingRule('addNewSeason');
                                }}
                            >
                                <span className="add-btn-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#333333" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                                </span>
                                <span className="add-btn-txt">Add New Pricing Season</span>
                            </Button>
                            :
                            null
                        }
                    </>
                )
                    :
                    null
                }

            </CustomTabPanel>

            <CustomTabPanel className="custom-tab-panel inactive" value={tabPanelIndex} index={1}>
                <OverlayScrollbarsComponent
                    className="custom-overlay-scrollbar scrollable-tab-container"
                    element="div"
                    options={{
                        scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                        overflow: { x: 'hidden', y: 'scroll', }
                    }}
                    defer
                >
                    <Box className='tab-container inactive'>
                        {inactiveSeasons && inactiveSeasons.length ?
                            (<>
                                {inactiveSeasons.find((season) => season.isRoomTypeDifference === true || season.isBaseRoomTypeChanged === true) &&
                                    <Box className="warning-container">
                                        {warningIcon}
                                        <Box className="warning-msg">Inventory changes have cleared some pricing rules. Please review and update to continue.</Box>
                                    </Box>
                                }
                                {inactiveSeasons.map((season, i) => {
                                    //Filter tabs
                                    return (
                                        <SeasonAccordion
                                            key={season.id}
                                            ref={(el) => (accordionRefs.current[season.id] = el)}
                                            season={season}
                                            updatePricingSeasonsUI={updatePricingSeasonsUI}
                                            manageSeasonChangeFunc={manageSeasonChangeFunc}
                                            isReadOnlyMode={isReadOnlyMode}
                                            discardCount={discardCount}
                                            globalErrorMsg={globalErrorMsg}
                                            copyInputCount={copyInputCount}
                                            addNewPricingRule={addNewPricingRule}
                                            scrollTopSeason={scrollTopSeason}
                                            inventoryRoomCodes={inventoryRoomCodes}
                                            inventoryRoomSettings={inventoryRoomSettings}
                                        />
                                    )
                                })}
                            </>)
                            :
                            (<EmptyScreen type="noData" msg="You Don’t Have Any Inactive Seasons Right Now" />)
                        }
                    </Box>
                </OverlayScrollbarsComponent>
            </CustomTabPanel>

            <CustomTabPanel className="custom-tab-panel expired" value={tabPanelIndex} index={2}>
                <OverlayScrollbarsComponent
                    className="custom-overlay-scrollbar scrollable-tab-container"
                    element="div"
                    options={{
                        scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                        overflow: { x: 'hidden', y: 'scroll', }
                    }}
                    defer
                >
                    <Box className='tab-container expired'>

                        {expiredSeasons && expiredSeasons.length ?
                            (<>
                                {expiredSeasons.map((season, i) => {
                                    //Filter tabs
                                    return (
                                        <SeasonAccordion
                                            key={season.id}
                                            ref={(el) => (accordionRefs.current[season.id] = el)}
                                            season={season}
                                            updatePricingSeasonsUI={updatePricingSeasonsUI}
                                            manageSeasonChangeFunc={manageSeasonChangeFunc}
                                            isReadOnlyMode={isReadOnlyMode}
                                            discardCount={discardCount}
                                            globalErrorMsg={globalErrorMsg}
                                            copyInputCount={copyInputCount}
                                            addNewPricingRule={addNewPricingRule}
                                            scrollTopSeason={scrollTopSeason}
                                            inventoryRoomCodes={inventoryRoomCodes}
                                            inventoryRoomSettings={inventoryRoomSettings}
                                        />
                                    )
                                })}
                            </>)
                            :
                            (<EmptyScreen type="noData" msg="You Don’t Have Any Expired Seasons Right Now" />)
                        }
                    </Box>
                </OverlayScrollbarsComponent>
            </CustomTabPanel>

            <ReCalibratePopup open={showRecalibratePopup} onClose={closeRecalibratePopup} handleRecalibrate={handleRecalibrate} />
            <ReCalibratingPopup open={showRecalibratingPopup} onClose={closeRecalibratingPopup} />
            {/* This will show in pricing tile */}
            {/* <UpdateRequiredPopup open={false} /> */}
        </Box>
    );
}

export default PricingSeasons;